var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotifications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.854a1.823 1.823 0 001.824-1.824H6.176c0 1.008.816 1.824 1.824 1.824zM15.6 15.537l-1.183-1.183v-5.5a6.41 6.41 0 00-5.042-6.26V1.52C9.375.76 8.761.146 8 .146c-.76 0-1.375.614-1.375 1.375v1.072a6.41 6.41 0 00-5.042 6.261v5.5L.401 15.537c-.578.577-.174 1.567.642 1.567h13.905c.825 0 1.229-.99.651-1.567z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotifications);
export default __webpack_public_path__ + "static/media/icon_notifications.af2a8ccc126bf1026302a3e25e133ce0.svg";
export { ForwardRef as ReactComponent };